import { deepCopyJson } from "@classdojo/monsterverse-utils";

type PCEventCallback = (...args: unknown[]) => void;

export class PCAppEventHandler {
  private _events = new Map<string, PCEventCallback[]>();
  private _registrationEvents = new Map<string, PCEventCallback[]>();

  constructor(private _iframeEl: HTMLIFrameElement) {}

  fire(name: string, ...args: unknown[]) {
    const data = {
      eventName: name,
      eventValues: deepCopyJson(args),
    };
    try {
      this._iframeEl.contentWindow?.postMessage(data, "*");
    } catch (err) {
      const msg = JSON.stringify({ data });
      throw new AggregateError([err], `postMessage failed: Launcher PCAppEventHandler: ${msg}`);
    }
  }

  hasEvent(name: string) {
    return this._events.has(name);
  }

  on(name: string, callback: PCEventCallback) {
    let events = this._events.get(name);
    if (!events) {
      events = [];
    }
    events.push(callback);
    this._events.set(name, events);

    const registrationCallbacks = this._registrationEvents.get(name);
    if (registrationCallbacks) {
      for (const callback of registrationCallbacks) {
        callback();
      }
    }
  }

  post(evt: { eventName: string; eventValues?: unknown[] }) {
    const callbacks = this._events.get(evt.eventName);
    if (callbacks) {
      for (const callback of callbacks) {
        if (evt.eventValues) {
          callback(...evt.eventValues);
        } else {
          callback();
        }
      }
    }
  }

  onRegistration(name: string, callback: PCEventCallback) {
    let registrationEvents = this._registrationEvents.get(name);
    if (!registrationEvents) {
      registrationEvents = [];
    }
    registrationEvents.push(callback);
    this._registrationEvents.set(name, registrationEvents);
    if (this.hasEvent(name)) {
      callback();
    }
  }
}
